module.exports = __webpack_public_path__ + "img/zh.c5e9dacc.svg";